/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Change_Account_Credit_AppliedInputs */

const en_plan_change_account_credit_applied = /** @type {(inputs: Plan_Change_Account_Credit_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account credit applied`)
};

const es_plan_change_account_credit_applied = /** @type {(inputs: Plan_Change_Account_Credit_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saldo a favor aplicado`)
};

/**
* | output |
* | --- |
* | "Account credit applied" |
*
* @param {Plan_Change_Account_Credit_AppliedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_change_account_credit_applied = /** @type {((inputs?: Plan_Change_Account_Credit_AppliedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Change_Account_Credit_AppliedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_change_account_credit_applied(inputs)
	return en_plan_change_account_credit_applied(inputs)
});